import style from './style';

const ReturnButton = props => {
    const { loadedImages, site, siteStyle } = props;

    return (
        <div class={`${style['return-button-outer']} ${style[`return-button-outer--${site}`]}`}>
            <button
                class={`${style['return-button']} ${style[`return-button--${site}`]}`}
                onClick={() => props.handleSiteChange(site - 1, { isReturn: true }, loadedImages)}
            >
                &lt;&lt;&lt; В предыдущий эпизод ({site - 1})
            </button>
        </div>
    );
}

export default ReturnButton;
